import PCIRepository from '@/shared/http/repositories/pci/pci'
import LpuRepository from '@/shared/http/repositories/pci/lpu'
import LpuPciRepository from '@/shared/http/repositories/pci/lpupci'
import ContractsRepository from '@/shared/http/repositories/pci/contract'
import { AgGridVue } from 'ag-grid-vue'
import ItemTreeView from '../components/treeview/ItemTreeView'
import { loading, toast } from '@/shared/utils/UIHelper'
import ActionsForm from '@/shared/mixins/actionsForm'
import gridMixin from '../mixins/gridMixin'
import itemMixim from '../mixins/itemMixim'
import CompanyMixin from '@/store/module/company/mixin'
import PCIItemRepository from '@/shared/http/repositories/pci/pciItem'
import WorkPCIRepository from '@/shared/http/repositories/pci/workpci'
import recordAccessControl from '@/shared/mixins/recordAccessControl'
import Roles from '@/shared/utils/roles'
import Log from './log'
import CompanyPciDocsRepository from '@/shared/http/repositories/pci/companyPciDocs'
import { uuid } from 'uuidv4'

export default {
  name: 'Mounting',
  mixins: [ActionsForm, gridMixin, itemMixim, CompanyMixin, recordAccessControl],
  data () {
    return {
      roles: Roles,
      subsidiaries: null,
      contracts: [],
      contractsToLink: [],
      subsidiarieInput: null,
      noSubsidiarie: true,
      selectedContract: {},
      subsidiarieId: null,
      columnDefs: null,
      contractToExport: null,
      pciItems: null,
      pciItemsTree: null,
      pciItemsAllocationTree: null,
      findText: '',
      exportContracts: [],
      showLogs: false,
      showAllocationTreeview: false,
      showPciItemsModal: false,
      showExportModal: false,
      itemDescription: '',
      lpuPci: null,
      listLpu: [],
      listLpuSel: [],
      listLpuAll: [],
      addLpu: null,
      noSearch: false,
      inconsistencies: [],
      selectedLine: null
    }
  },
  components: {
    AgGridVue,
    ItemTreeView,
    Log
  },
  computed: {
    getItemAllocationDescription () {
      if (this.lpuPci) {
        const pciModeloItem = this.lpuPci.pciModeloItem
        return pciModeloItem ? pciModeloItem.pais + ' > ' + pciModeloItem.descricao : ''
      }
    }
  },
  methods: {
    onLoad () {
      if (this.company.id !== null) {
        this.columnDefs = [
          {
            headerName: this.$lang.PCI.DataTable.Contract,
            width: 300,
            field: 'contract'
          },
          {
            headerName: this.$lang.PCI.DataTable.Creation,
            width: 50,
            field: 'creation',
            type: 'dateColumn'
          },
          {
            headerName: this.$lang.PCI.DataTable.ArchivedWorks,
            width: 50,
            field: 'archivedWorks',
            type: 'dateColumn'
          },
          {
            headerName: this.$lang.PCI.DataTable.UserArchivedWorks,
            width: 200,
            field: 'userArchivedWorks'
          },
          {
            headerName: this.$lang.PCI.DataTable.ArchivedFinance,
            width: 50,
            field: 'archivedFinance',
            type: 'dateColumn'
          },
          {
            headerName: this.$lang.PCI.DataTable.UserArchivedFinance,
            width: 200,
            field: 'userArchivedFinance'
          }
        ]

        // Search by subsidiarie contracts
        loading.push()
        ContractsRepository.GetAll(this.company.id)
          .then(response => {
            // Verifies response status code
            if (response.data.code > 0) {
              // Stores only relevant data to render in grid
              let contracts = response.data.data.map(contract => {
                return {
                  contract: contract.descricao,
                  type: contract.descricaoModelo,
                  creation: contract.criacaoPCI,
                  archivedWorks: contract.arquivamentoPCI,
                  archivedFinance: contract.arquivamentoFinanceiroPCI,
                  userArchivedWorks: contract.usuarioArquivPCI,
                  userArchivedFinance: contract.usuarioArquivFinancPCI,
                  contractID: contract.contratoID,
                  linkedContractID: contract.contratoVinculadoID,
                  pciID: contract.pciid,
                  lpusPci: contract.lpusPci
                }
              })

              // Set global contracts to local contracts
              this.contracts = contracts
              // this.availableContracts = contracts

              this.$nextTick(() => {
                setTimeout(() => {
                  this.gridOptions.api.sizeColumnsToFit()
                  this.gridOptions.api.deselectAll()
                  this.gridOptions.api.redrawRows()
                }, 200)
              })
            } else {
              toast.error(this.$lang.Common.CouldNotLoadRegister)
            }
          })
          .catch(error => {
            console.log(error)
            toast.error(this.$lang.Common.CouldNotLoadRegister)
          })
          .finally(() => loading.close())

        loading.push()
        LpuRepository.GetAll(this.company.id)
          .then(response => {
            if (response.data.code > 0) {
              this.listLpuAll = response.data.data.sort((a, b) => a.descricao < b.descricao ? -1 : a.text > b.text ? 1 : 0)
              this.listLpu = this.listLpuAll.filter(el => el.status === 1)
            } else {
              toast.error(this.$lang.Common.CouldNotLoadRegister)
            }
          })
          .finally(() => loading.close())
      }
    },
    onSelectLine () {
      this.selectedLine = this.gridOptions.api.getSelectedRows().length > 0 ? this.gridOptions.api.getSelectedRows()[0] : null
    },
    createMsgBox (msg) {
      const h = this.$createElement
      let messageVNode = h('div', [
        h('h4', [
          this.$lang.Common.LabelConfirmation
        ]),
        h('br')
      ])

      return this.$bvModal.msgBoxConfirm([messageVNode], {
        title: msg,
        centered: true,
        okTitle: this.$lang.Common.Yes,
        cancelTitle: this.$lang.Common.No,
        headerClass: 'justify-content-center'
      })
    },
    onArchiveWork () {
      this.createMsgBox(this.$lang.PCI.Mounting.ArchiveWorkConfirm)
        .then(value => {
          if (value) {
            this.archive('obras', 'arquivar')
          }
        })
    },
    onUnarchiveWork () {
      this.createMsgBox(this.$lang.PCI.Mounting.UnarchiveWorkConfirm)
        .then(value => {
          if (value) {
            this.archive('obras', 'desarquivar')
          }
        })
    },
    onArchiveFinance () {
      this.createMsgBox(this.$lang.PCI.Mounting.ArchiveFinanceConfirm)
        .then(value => {
          this.archive('financeiro', 'arquivar')
        })
    },
    onUnarchiveFinance () {
      this.createMsgBox(this.$lang.PCI.Mounting.UnarchiveFinanceConfirm)
        .then(value => {
          this.archive('financeiro', 'desarquivar')
        })
    },
    archive (department, type) {
      loading.push()
      ContractsRepository.Archive(this.selectedLine.pciID, department, type)
        .then(response => {
          if (response.data.code > 0) {
            this.onLoad()
          } else {
            toast.error(this.$lang.Common.CouldNotSave)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    showLog () {
      this.showLogs = true
      this.$nextTick(() => {
        this.$refs.Log.show(this.selectedLine)
      })
    },
    onScrollTo (offsetTop) {
      document.getElementsByClassName('modal-body')[0].scrollTo({top: offsetTop, behavior: 'smooth'})
    },
    onShowAllocationTreeview () {
      this.showAllocationTreeview = true
      if (this.lpuPci) {
        this.$nextTick(() => {
          this.$refs.allocationTreeview.setSelected(this.lpuPci.pciModeloItem)
        })
      }
    },
    onSelectAllocationItem (item) {
      this.lpuPci.pciModeloItemID = item.id

      if (item.type !== 5) {
        toast.warning(this.$lang.PCI.AT.WarningOnlyAllowedTecAnalysis)
        return
      }

      loading.push()
      this.showMirrorTreeview = false
      PCIItemRepository.Find(item.id)
        .then(response => {
          if (response.data.code > 0) {
            this.$set(this.lpuPci, 'pciModeloItem', response.data.data)
            this.showAllocationTreeview = false
          } else {
            toast.error(this.$lang.Common.CouldNotLoadRegister)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    // Select a contract to edit
    selectContract (event, contract = null) {
      // Get selected contract row
      if (contract === null) {
        contract = this.gridOptions.api.getSelectedRows().length === 1 ? this.gridOptions.api.getSelectedRows()[0] : null
      }

      if (contract !== null) {
        this.ACCheckIn('pci', contract.contractID)
          .then(response => {
            if (response.block) {
              toast.error(this.$lang.Common.Alerts.BlockedAccess + ' ' + response.name)
              return
            }
            this.contractsToLink = this.contracts.filter(ct => ct.contractID !== contract.contractID)
            loading.push()

            ContractsRepository.Get(contract.contractID)
              .then(response => {
                if (response.data.code > 0) {
                  const ct = response.data.data
                  this.selectedContract = {
                    contract: ct.descricao,
                    type: ct.descricaoModelo,
                    creation: ct.criacaoPCI,
                    archivedWorks: ct.arquivamentoPCI,
                    archivedFinance: ct.arquivamentoFinanceiroPCI,
                    userArchivedWorks: ct.usuarioArquivPCI,
                    userArchivedFinance: ct.usuarioArquivFinancPCI,
                    contractID: ct.contratoID,
                    linkedContractID: ct.contratoVinculadoID,
                    pciID: ct.pciid,
                    lpusPci: ct.lpusPci
                  }
                  LpuPciRepository.GetAllByPci(this.selectedContract.pciID)
                    .then(response => {
                      if (response.data.code > 0) {
                        this.listLpuSel = response.data.data
                        this.listLpu = this.listLpuAll.filter(element => element.status === 1 && !this.listLpuSel.some(f => f.lpuID === element.id))
                      }
                    })

                  // Request by company pci models
                  let getPciItems = this.selectedContract.pciID
                    ? PCIRepository.GetPCIItemsByPciID(this.company.id, this.selectedContract.pciID)
                    : PCIRepository.GetPCIItems(this.company.id)

                  getPciItems
                    .then(response => {
                      // Verifies response status code
                      if (response.data.code > 0) {
                        const listAlloc = response.data.data.map(item => {
                          return {
                            parentId: item.itemPaiID,
                            name: item.descricao,
                            type: item.tipo,
                            id: item.id
                          }
                        })

                        this.pciItemsAllocationTree = this.getHierarchy(listAlloc)
                        const list = response.data.data.map(item => {
                          const obj = {
                            id: item.id,
                            name: item.descricao,
                            tipo: item.tipo,
                            value: item.codigo,
                            tipoEspelho: item.tipoEspelho,
                            codigoEspelho: item.codigoEspelho,
                            parentId: item.itemPaiID,
                            checked: item.checked,
                            possuiCor: item.possuiCor,
                            colorido: item.colorido,
                            linhaCandidato: item.linhaCandidato,
                            bloqueiaRetroativoModelo: item.bloqueiaRetroativoModelo,
                            bloqueiaRetroativo: item.bloqueiaRetroativo,
                            automations: item.automatizacoes ? item.automatizacoes.map(it => {
                              return {
                                text: it.nome,
                                value: {
                                  id: '00000000-0000-0000-0000-000000000000',
                                  pciModeloItemStatusID: it.id,
                                  statusValores: it.statusValores
                                },
                                automatico: it.automatico
                              }
                            }) : [],
                            validations: item.validacoes ? item.validacoes.map(it => {
                              return {
                                text: it.nome,
                                value: {
                                  id: '00000000-0000-0000-0000-000000000000',
                                  pciModeloItemValidID: it.id,
                                  regrasValid: it.regrasValid
                                },
                                automatico: it.automatico
                              }
                            }) : [],
                            mountAutomations: item.automatizacoesMont ? item.automatizacoesMont.map(it => {
                              return {
                                id: '00000000-0000-0000-0000-000000000000',
                                pciModeloItemStatusID: it.pciModeloItemStatusID,
                                statusValores: it.pciModeloItemStatus.statusValores
                              }
                            }) : [],
                            mountValidations: item.validacoesMont ? item.validacoesMont.map(it => {
                              return {
                                id: '00000000-0000-0000-0000-000000000000',
                                pciModeloItemValidID: it.pciModeloItemValidID,
                                regrasValid: it.pciModeloItemValid.regrasValid
                              }
                            }) : []
                          }

                          return obj
                        })

                        this.pciItems = list
                        // Set global pciItemsTree to local pciItemsTree
                        this.pciItemsTree = this.getHierarchy(list)

                        this.validInconsistencies()

                        // Show PCI itens modal
                        this.showPciItemsModal = true

                        this.$nextTick(() => {
                          this.$refs.mountingTreeview.openChecked()
                        })
                      } else {
                        toast.error(this.$lang.Common.CouldNotLoadRegister)
                      }
                      loading.close()
                    })
                    .catch(error => {
                      console.log(error)
                      toast.error(this.$lang.Common.CouldNotLoadRegister)
                      loading.close()
                    })
                }
              })
          })
          .catch(err => {
            console.log(err)
            toast.error(this.$lang.Common.CouldNotLoadRegister)
          })
      }
    },
    onCheckItem (item) {
      this.validInconsistencies()
      if (!this.selectedContract.pciID) {
        item.mountAutomations = []
        item.mountValidations = []
        item.colorido = true

        if (item.checked) {
          const statusAutom = item.automations.filter(it => it.automatico)[0]

          if (statusAutom) {
            item.mountAutomations.push({
              id: '00000000-0000-0000-0000-000000000000',
              pciModeloItemStatusID: statusAutom.value.pciModeloItemStatusID
            })
          }

          const validAutom = item.validations.filter(it => it.automatico)[0]

          if (validAutom) {
            item.mountValidations.push({
              id: '00000000-0000-0000-0000-000000000000',
              pciModeloItemValidID: validAutom.value.pciModeloItemValidID
            })
          }
        }
      }
    },
    onAddLpu (event) {
      this.listLpuSel.push({
        id: uuid(),
        lpuID: event.id,
        pciID: this.selectedLine.pciID,
        lpu: event
      })
      this.listLpuSel.sort((a, b) => a.lpu.descricao < b.lpu.descricao ? -1 : a.text > b.text ? 1 : 0)
      this.addLpu = null
      const idx = this.listLpu.findIndex(l => l.id === event.id)
      this.listLpu.splice(idx, 1)
    },
    onDeleteLpu (index) {
      const lpu = this.listLpuSel.splice(index, 1)
      const lpuAll = this.listLpuAll.find(l => l.id === lpu[0].lpuID)
      this.listLpu.push(lpuAll)
      this.listLpu.sort((a, b) => a.descricao < b.descricao ? -1 : a.text > b.text ? 1 : 0)
    },
    // Submit PCI Itens selection
    submitPCI (event) {
      if (this.inconsistencies.length > 0) {
        toast.error(this.$lang.PCI.Mounting.SubmitButtonValidationDescription, this.$lang.PCI.Mounting.SubmitButtonValidationTitle)
        event.preventDefault()
        return
      }
      // Store checked pci items
      let checkedItems = []

      const verifyChildrens = root => {
        // Loop all passed PCI items
        for (let subitem in root) {
          // Stores current item
          let item = root[subitem]

          // Verifies if item is checked
          if (item.checked) {
            // Push item to checkedItems
            checkedItems.push({
              id: item.id,
              codigo: item.value,
              descricao: item.name.split('- ')[1],
              itemPaiID: item.parentId,
              colorido: item.colorido,
              linhaCandidato: item.linhaCandidato,
              bloqueiaRetroativo: item.bloqueiaRetroativo,
              validacoesMont: item.mountValidations,
              automatizacoesMont: item.mountAutomations
            })
          }

          // Verifies if item has childrens
          if (item.children) {
            verifyChildrens(item.children)
          }
        }
      }

      // Get selected PCI Itens
      verifyChildrens(this.pciItemsTree)

      // Stores contract(s) to mount
      let data = []
      let lpuPcis = []
      this.listLpuSel.forEach(e => {
        lpuPcis.push({
          LpuID: e.lpuID
        })
      })

      let clone = this.contractToExport !== null
      if (this.contractToExport) {
        // Set to mount all exported contracts
        data = this.contractToExport.map(contract => {
          return {
            contratoID: contract.contratoID,
            lpusPci: lpuPcis,
            pciItems: checkedItems
          }
        })
      } else {
        data.push({
          contratoID: this.selectedContract.contractID,
          contratoVinculadoID: this.selectedContract.linkedContractID,
          lpusPci: lpuPcis,
          pciItems: checkedItems
        })
      }

      loading.push()

      // Request to service mount PCI
      PCIRepository.MountPCI(clone, data)
        .then(response => {
          // Set a toastr success message
          if (response.data.code > 0) {
            toast.success('A PCI foi montada com sucesso', 'Sucesso')
            const contract = {
              contract: response.data.data.descricao,
              type: response.data.data.descricaoModelo,
              creation: response.data.data.criacaoPCI,
              archivedWorks: response.data.data.arquivamentoPCI,
              archivedFinance: response.data.data.arquivamentoFinanceiroPCI,
              userArchivedWorks: response.data.data.usuarioArquivPCI,
              userArchivedFinance: response.data.data.usuarioArquivFinancPCI,
              linkedContractID: response.data.data.contratoVinculadoID,
              contractID: response.data.data.contratoID,
              modelId: response.data.data.pciModeloID
            }
            this.selectedContract = contract

            const node = this.gridOptions.api.getRowNode(data.contratoID + '|' + data.pciModeloId)
            if (node) node.setData(contract)

            this.ACCheckOut()
          } else {
            toast.error(this.$lang.Common.CouldNotSave)
          }
        })
        .catch(error => {
          // If request fails
          // Set a toastr success message
          console.log(error)
          toast.error(this.$lang.Common.CouldNotSave)
        })
        .finally(() => {
          loading.close()

          this.contractToExport = null

          this.$nextTick(() => {
            setTimeout(() => {
              const contracts = data.map(d => {
                return d.contratoID
              })
              CompanyPciDocsRepository.UpdatePermissions(this.company.id, contracts)
              data.forEach(contract => {
                WorkPCIRepository.AutomatizationByContract(contract.contratoID)
                WorkPCIRepository.ValidationByContract(contract.contratoID)
              })
            }, 1000)
          })
        })
    },
    closePCI () {
      this.ACCheckOut()
    },
    // Open export menu
    openExportMenu () {
      let contract = this.gridOptions.api.getSelectedRows().length === 1 ? this.gridOptions.api.getSelectedRows()[0] : null

      if (contract === null) {
        return
      }

      // Set global contract and pci model id as the selected
      this.selectedContract = contract

      // Show loading screen
      loading.push()

      // Search by subsidiarie contracts
      ContractsRepository.GetAll(this.company.id)
        .then(response => {
          // Verifies response status code
          if (response.data.code > 0) {
            // Stores only relevant data to render in grid
            let contracts = response.data.data
              .reduce((filtered, ct) => {
                if (ct.contratoID !== contract.contractID) {
                  filtered.push(
                    {
                      contratoID: ct.contratoID,
                      contract: ct.descricao,
                      pciID: ct.pciid,
                      show: true
                    }
                  )
                }
                return filtered
              }, [])

            this.exportContracts = contracts
          } else {
            toast.error(this.$lang.Common.CouldNotLoadRegister)
          }
          loading.close()
        })
        .catch(error => {
          loading.close()
          console.log(error)
          toast.error(this.$lang.Common.CouldNotLoadRegister)
        })

      this.showExportModal = true
    },
    selectContractExport (event) {
      // Get only checked contracts
      let exportedContracts = this.exportContracts.filter(contract => contract.checked === true)

      if (exportedContracts.length) {
        this.contractToExport = exportedContracts
        this.showExportModal = false

        this.selectContract(event, this.selectedContract)
      }
    },
    searchExportContract (event) {
      let pattern = event.target.value.toLowerCase()

      this.exportContracts.forEach(item => {
        if (item.contract.toLowerCase().indexOf(pattern) === -1 && pattern.length > 0) {
          item.show = false
        } else {
          item.show = true
        }
      })
    },
    onCheckAutomations (value) {
      this.validInconsistencies()
      if (value.length > 1) {
        return false
      }
    },
    onCheckValidations () {
      this.validInconsistencies()
    },
    validInconsistencies () {
      let items = []
      const verifyChildrens = (root, routeName) => {
        root.forEach(item => {
          let name = (routeName == null ? '' : routeName + ' > ') + item.name
          items.push({
            id: item.id,
            name: name,
            checked: item.checked,
            codigo: item.value
          })
          if (item.children) {
            verifyChildrens(item.children, name)
          }
        })
      }
      verifyChildrens(this.pciItemsTree, null)

      this.inconsistencies = []
      const verifyAutomations = (root, routeName) => {
        root.forEach(itemOrigin => {
          let originName = (routeName == null ? '' : routeName + ' > ') + itemOrigin.name
          if (itemOrigin.mountAutomations && itemOrigin.checked === true) {
            itemOrigin.mountAutomations.forEach(itemAutomations => {
              if (itemAutomations.statusValores) {
                itemAutomations.statusValores.forEach(statusValores => {
                  if (statusValores.regrasStatus) {
                    statusValores.regrasStatus.forEach(regras => {
                      let itemDestiny = items.filter(i => (i.id === regras.pciModeloItemID || i.id === regras.pciModeloItemIDComparar) && i.checked === false)
                      if (itemDestiny) {
                        itemDestiny.forEach(item => {
                          if (!this.inconsistencies.find(i => i.destinyId === item.id)) {
                            this.inconsistencies.push({
                              tipo: 'Automations',
                              destinyId: item.id,
                              destinyName: `(${item.value}) ${item.name}`,
                              originId: itemOrigin.id,
                              originName: `(${itemOrigin.value}) ${originName}`
                            })
                          }
                        })
                      }
                    })
                  }
                })
              }
            })
          }
          if (itemOrigin.children) {
            verifyAutomations(itemOrigin.children, originName)
          }
        })
      }
      verifyAutomations(this.pciItemsTree, null)

      const verifyValidations = (root, routeName) => {
        root.forEach(itemOrigin => {
          let originName = (routeName == null ? '' : routeName + ' > ') + itemOrigin.name
          if (itemOrigin.mountValidations && itemOrigin.checked === true) {
            itemOrigin.mountValidations.forEach(itemValidations => {
              if (itemValidations.regrasValid) {
                itemValidations.regrasValid.forEach(regras => {
                  let itemDestiny = items.filter(i => (i.id === regras.pciModeloItemID || i.id === regras.pciModeloItemIDComparar) && i.checked === false)
                  if (itemDestiny) {
                    itemDestiny.forEach(item => {
                      if (!this.inconsistencies.find(i => i.destinyId === item.id)) {
                        this.inconsistencies.push({
                          tipo: 'Validations',
                          destinyId: item.id,
                          destinyName: `(${item.value}) ${item.name}`,
                          originId: itemOrigin.id,
                          originName: `(${itemOrigin.value}) ${originName}`
                        })
                      }
                    })
                  }
                })
              }
            })
          }
          if (itemOrigin.children) {
            verifyValidations(itemOrigin.children, originName)
          }
        })
      }
      verifyValidations(this.pciItemsTree, null)

      const verifyMirroring = (root, routeName) => {
        root.forEach(itemOrigin => {
          let originName = (routeName == null ? '' : routeName + ' > ') + itemOrigin.name
          if (itemOrigin.codigoEspelho > 0 && itemOrigin.tipoEspelho < 3 && itemOrigin.checked === true) {
            let itemDestiny = items.filter(i => i.codigo === itemOrigin.codigoEspelho && i.checked === false)
            if (itemDestiny) {
              itemDestiny.forEach(item => {
                if (!this.inconsistencies.find(i => i.destinyId === item.id)) {
                  this.inconsistencies.push({
                    tipo: 'Mirroring',
                    destinyId: item.id,
                    destinyName: `(${item.codigo}) ${item.name}`,
                    originId: itemOrigin.id,
                    originName: `(${itemOrigin.value}) ${originName}`
                  })
                }
              })
            }
          }
          if (itemOrigin.children) {
            verifyMirroring(itemOrigin.children, originName)
          }
        })
      }
      verifyMirroring(this.pciItemsTree, null)
    }
  }
  // ,
  // watch: {
  //   keyFilterDate: function (value) {
  //     if (value === '') {
  //       this.availableContracts = this.contracts
  //       return
  //     }
  //     let allAvailable = this.contracts
  //     allAvailable = allAvailable.filter(x => new Date(x.creation) > new Date(value))
  //     if (allAvailable.length) {
  //       this.availableContracts = allAvailable
  //     } else {
  //       this.availableContracts = []
  //     }
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/views/private/operational/pci/mounting/mounting.js